<template>
  <div class="electiveOperationList">
    <div class="nav">
      <div class="title">
        <i class="iconfont icon-shoushugongzuoliang"></i>
        <p>随访队列</p>
      </div>
      <div class="line"></div>
    </div>
    <div class="search">
      <el-col :span="7">
        <span class="dateTitle">检索</span>
        <el-date-picker
          clearable
          v-model="searchDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 80%"
        ></el-date-picker>
      </el-col>
      <el-col :span="3" class="searchInput">
        <el-autocomplete
          v-model="searchGroupName"
          :fetch-suggestions="querySearchQueueName"
          @select="selectsearchGroupName"
          placeholder="队列分组"
          type="text"
          class="popInput"
          prefix-icon="el-icon-search"
          clearable
        ></el-autocomplete>      
      </el-col>
      <el-col :span="3" class="searchInput">
        <el-input v-model="searchNote" placeholder="备注信息" prefix-icon="el-icon-search" clearable></el-input>
      </el-col>
      <el-col :span="3" class="searchInput">
        <el-input v-model="searchDoctor" placeholder="负责医生" prefix-icon="el-icon-search" clearable></el-input>
      </el-col>
      <el-col :span="3" class="searchInput">
        <el-input v-model="searchPatients"   placeholder="患者姓名/ID" prefix-icon="el-icon-search"  clearable></el-input>
      </el-col>
      <el-col :span="5" class="btnBottom">
        <!-- <button
          class="btn iconfont leftItemSubmit yuyuetips"
          style="padding: 0"
          @click.prevent="refreshList"
          v-show="hasNewcosmetRegistrationElective"
        >
          有新预约
          <i class="iconfont icon-004shuaxin"></i>
        </button> -->
        <button
          class="btn iconfont leftItemSubmit"
          @click.prevent="showAddFollowupPlan"
          style="padding: 0;margin-right: 8px"
        >新建随访计划({{checkedNum}})</button>
        <button
          class="btn iconfont leftItemSubmit"
          @click.prevent="exportExcel()"
          style="padding: 0"
          v-acl="['cosmet_registration']"
        >导出Excel</button>
      </el-col>
    </div>
    <div class="line lineGray"></div>
    <div class="fotter" style="overflow:auto">
      <template>
        <el-table :data="tableData" stripe style="width: 100%" 

        @select-all="selectchageall"
        @cell-dblclick="dbclickCell">

          <el-table-column type="selection" align="center" width="50">
              <template v-slot="scope">
                  <el-checkbox v-model="scope.row.checked" 
                      @change="handleCheckChange(scope.row)"></el-checkbox>
              </template>
          </el-table-column>

          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column
            v-for="(item,index) in tableTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width-100"
          ></el-table-column>

          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
                <i class="el-icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>

          <el-table-column label="" >
            <template slot-scope="scope">
              <el-button
                @click.stop="showRevise(scope.$index,scope.row)"
                size="mini"
                type="primary"
                icon="el-icon-edit"
                style="width: 50px;display:inline-block;"
              ></el-button>
            </template>
          </el-table-column>


        </el-table>
        <el-pagination
                @current-change="handleCurrentChange"
                :current-page="this.pageNumber"
                :page-size="this.pageSize"
                layout="total, prev, pager, next, jumper"
                :total="this.pageTotal">
        </el-pagination>
      </template>
<!--      <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="this.pageNumber"
              :page-size="this.pageSize"
              layout="total, prev, pager, next,jumper"
              :total="this.pageTotal">
      </el-pagination>-->

  <!--    <div class="pageFen">
        <el-button-group>
          <el-button type="primary" icon="el-icon-arrow-left" @click="clickPrev">上一页</el-button>
          <el-button type="primary" @click="clickNext">
            下一页
            <i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>
          </el-button>
        </el-button-group>
      </div>-->
    </div>

    <!-- 添加随访患者 -->
    <div class="resetFollowup">
      <el-dialog
        title="添加患者至随访队列"
        class="dialog"
        :visible.sync="reviseInfo"
        width="714px"
        :close-on-click-modal="false"
        @close="reviseInfoClose"
      >
        <div class="navBorder"></div>
        <div id="modifyFollowupPatient">
          <!-- 添加随访患者时呈现 -->
          <el-form  inline>
            <el-col :span="24">
              <div class="leftItem">
                <p v-if="isAddPatient" class="rightItemTitle popTitleDialog">待添加患者信息</p>
                <el-table v-if="isAddPatient" :data="newFollowupPatients" stripe style="width: 100%">
                  <el-table-column
                    v-for="(item,index) in tableTitle2"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                  ></el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-form>
          <el-form :model="form2" :rules="rules" ref="form2" inline>
            <el-col :span="24">
              <div class="leftItem">
                <p class="rightItemTitle popTitleDialog">队列名称</p>
                <el-form-item prop ref="form2_queue_name">
                  <el-autocomplete
                    v-model="form2.queue_name"
                    :fetch-suggestions="querySearchQueueName"
                    @select="selectQueueName"
                    placeholder="选择已有队列或新建队列"
                    type="text"
                    class="popInput"
                  ></el-autocomplete>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="leftItem">
                <p class="rightItemTitle popTitleDialog">疾病类型</p>
                <el-form-item prop ref="form2QueueType">
                  <el-input v-model="form2.queue_type" type="text" class="popInput"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-form>

          <el-form :model="form2" :rules="rules" ref="form2" inline>
            <el-col :span="24">
              <div class="leftItem">
                <p class="rightItemTitle popTitleDialog">描述</p>
                <el-form-item prop ref="form2Descripition">
                  <el-input v-model="form2.descripition" type="text" class="popInput"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-form>

          <el-form :model="form2" :rules="rules" ref="form2" inline>
            <el-col :span="12" :offset="12">
              <button
                class="btn iconfont leftItemSubmit2"
                @click.prevent="addFollowupPatient"
                style="padding: 0"
                v-if="isAddPatient"
              >添加</button>
              <button
                class="btn iconfont leftItemSubmit2"
                @click.prevent="reviseFollowupPatient"
                style="padding: 0"
                v-else           
              >保存</button>
            </el-col>
          </el-form>
        </div>
      </el-dialog>
    </div>

    <!-- 添加随访计划 -->
    <div class="resetFollowup">
      <el-dialog
        title="随访计划信息编辑"
        class="dialog"
        :visible.sync="isShowAddFollowupPlan"
        width="714px"
        :close-on-click-modal="false"
        @close="closeAddFollowupPlan"
      >
        <div class="navBorder"></div>
        <div id="modifyFollowupPatient">
          <!-- 添加随访计划时呈现 -->
          <!-- <el-form  inline>
            <el-col :span="24">
              <div class="leftItem">
                <p v-if="isAddPatient" class="rightItemTitle popTitleDialog">待添加患者信息</p>
                <el-table v-if="isAddPatient" :data="newFollowupPatients" stripe style="width: 100%">
                  <el-table-column
                    v-for="(item,index) in tableTitle2"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                  ></el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-form> -->
          <el-form :model="form2" :rules="rules" ref="form2" inline>
            <el-col :span="12">
              <div class="leftItem">
                <p class="rightItemTitle popTitleDialog">描述</p>
                <el-form-item prop ref="form2_queue_name">
                  <el-autocomplete
                    v-model="form2.queue_name"
                    :fetch-suggestions="querySearchQueueName"
                    @select="selectQueueName"
                    type="text"
                    class="popInput"
                  ></el-autocomplete>
                </el-form-item>
              </div>
            </el-col>

          </el-form>

          <el-form :model="form2" :rules="rules" ref="form2" inline>
            <el-col :span="24">
              <div class="leftItem">
                <p class="rightItemTitle popTitleDialog">发送渠道</p>
                <el-form-item prop ref="form2Note">
                  <el-input v-model="form2.note" type="text" class="popInput"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-form>

          <el-form :model="form2" :rules="rules" ref="form2" inline>
            <el-col :span="12" :offset="12">
              <button
                class="btn iconfont leftItemSubmit2"
                @click.prevent="addFollowupPlan"
                style="padding: 0"
                v-if="isAddPatient"
              >添加</button>
              <button
                class="btn iconfont leftItemSubmit2"
                @click.prevent="reviseFollowupPatient"
                style="padding: 0"
                v-else           
              >保存</button>
            </el-col>
          </el-form>
        </div>
      </el-dialog>
    </div>


    <!-- <CosmetRegistrationConfig
      :isShowAddFollowupPlan="isShowAddFollowupPlan"
      @closeConfigPanel="closeConfigPanel"
    ></CosmetRegistrationConfig> -->
  </div>
</template>
<script>
// import removeCosmetRegistration from "../gql/removeCosmetRegistration.gql";
import getFollowupList from "../gql/getFollowupList.gql";
import followupTemplate from "../gql/getFollowupTemplate.gql";
import knowledgeDicTemplate from "../utils/knowledgeDicTemplate.js";
import moment from "moment";
import gql from "graphql-tag";
// import printCosmetRegExcel from "../utils/printCosmetRegExcel.js";
// import CosmetRegistrationConfig from "./CosmetRegistrationConfig.vue";
let times ;
export default {
  name: "followupList",
  data() {
    return {
      tableTitle: [
        { prop: "followup_status", label: "随访状态", width: "200" },
        { prop: "name", label: "姓名", width: "200" },
        { prop: "sex", label: "性别", width: "160" },
        { prop: "queue_name", label: "队列分组", width: "250" },        
        { prop: "record_person", label: "负责医生", width: "200" },
        { prop: "create_time", label: "添加时间", width: "200" },
        { prop: "update_time", label: "更新时间", width: "200" },
        { prop: "followup_plan_num", label: "随访计划数量", width: "200" },
        { prop: "followup_result_num", label: "随访结果数量", width: "200" },
        { prop: "note", label: "备注", width: "260" },
        { prop: "id_in_hospital", label: "ID号", width: "220" },
        { prop: "diagnoses", label: "诊断", width: "200" },
      ],
      
      // 添加随访患者时显示的列表
      tableTitle2: [
        { prop: "name", label: "姓名", width: "100" },
        { prop: "gender", label: "性别", width: "100" },
        { prop: "id_in_hospital", label: "ID号", width: "150" }
      ],


      formInline: {},
      searchDate: "",
      searchPatients: "",
      searchDoctor: "",
      searchStartDate: "",
      searchEndDate: "",
      searchGroupName:"",
      searchNote:"",
      tableData: [],
      pageSize: 9,
      pageTotal:0,
      pageNumber: 1,
      currentPage: 1,

      isShowAddFollowupPlan: false,

      // 是否打开随访患者信息编辑页面
      reviseInfo: false,
      // 是否添加随访患者，
      isAddPatient: false,
      // 拟添加患者列表
      newFollowupPatients:[],

      // 已建立的随访患者分组名称信息
      followupGroups: [],
      followupQueues: [], // 已建立的随访队列信息
      followupQueueNames: [], // 已建立的随访队列名称信息
      // 用于添加随访患者至队列，暂存随访队列信息
      form2: {
        followupId:-1,
        queue_id: '',
        queue_name: '',
        queue_type: '',
        description: '',
        status: '',
        note: ''
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        birthday: [{ required: true, trigger: "blur" }],
      },
      // 全选状态
      isIndeterminate: false,
      checkAll: false,
      // 勾选的拟加入随访的患者数量
      checkedNum:0,
    };
  },
  components: {
    // CosmetRegistrationConfig,
  },
  mixins: [knowledgeDicTemplate],
  created() {
    // 其他页面新建、修改后，向该页面传递刷新指令
    this.$root.$on("refreshFollowupList", async () => {
      console.log("In FollowupList, on refreshFollowupList, begin getFollowupPatientList");
      this.tableData = await this.getFollowupPatientList();
    });
  },
  beforeDestroy() {
    this.$root.$off("refreshFollowupList");
  },
  async mounted() {
    //await this.getKnowledgeDic();
    //await this.queryMyTemplate();
    // alert( document.body.clientHeight)
    this.tableData = await this.getFollowupPatientList();

    // 从患者列表点击"加入随访",打开新页面，利用query在新老页面之间传输参数
    console.log("In followupList.vue, recved query:",this.$route.query, ',this.$store.state.hasAddedNewFollowupPatient:',this.$store.state.hasAddedNewFollowupPatient);
    if(this.$route.query ){
      if(this.$route.query.newFollowupPatients){
        this.newFollowupPatients = JSON.parse(this.$route.query.newFollowupPatients);
        console.log("In followupList.vue, newFollowupPatients:", this.newFollowupPatients);

        // 打开添加随访患者的对话框 
        this.reviseInfo = true;
        // 设置添加随访患者标志
        this.isAddPatient= true;

        if (this.$refs.form2Note) {
          this.$refs.form2Note.resetField();
        }
        if (this.$refs.form2_queue_name) {
          this.$refs.form2_queue_name.resetField();
        }
        // 设置对话框 modal 数据为 ''
        this.form2.note = "";
        this.form2.queue_name = "";
        // 当点击“添加”按钮式，执行添加
      }
    }
  },
  watch: {

    async handleCurrentChange(val) {
      this.currentPage = val;
      await this.getFollowupPatientList();
      //await this.getPatientsDiagnoses();
    },

    async searchPatients(newVal) {
      this.searchPatients = newVal;
      this.pageNumber = 1
      this.tableData = await this.getFollowupPatientList();
    },
    async searchDoctor(newVal) {
      this.searchDoctor = newVal
      this.pageNumber = 1
      this.tableData = await this.getFollowupPatientList();
    },
    async searchDate(newVal) {
      if (newVal) {
        this.searchStartDate = moment(newVal[0]).format("YYYY-MM-DD");
        this.searchEndDate = moment(newVal[1]).format("YYYY-MM-DD");
      } else {
        this.searchStartDate = "";
        this.searchEndDate = "";
      }
      this.pageNumber = 1
      this.tableData = await this.getFollowupPatientList();
    },
    async searchGroupName(newVal) {
      this.searchGroupName = newVal
      this.pageNumber = 1
      this.tableData = await this.getFollowupPatientList();
    },
    async searchNote(newVal) {
      this.searchNote = newVal
      this.pageNumber = 1
      this.tableData = await this.getFollowupPatientList();
    },

    // async hasNewcosmetRegistrationElective(val) {
    //   if (val) {
    //     await this.refreshList();
    //   }
    // }
  },
  computed: {
    // hasNewcosmetRegistrationElective() {
    //   return this.$store.state.hasNewcosmetRegistrationElective;
    // }
  },
  methods: {
    async handleSizeChange(val) {
      this.pageNumber = val;
      this.pageSize = val
      this.tableData = await this.getFollowupPatientList();
    },
    async handleCurrentChange(val) {
      this.pageNumber = val;
      this.tableData = await this.getFollowupPatientList();
    },

    // 打开随访计划编辑对话框
    showAddFollowupPlan(){
      if(this.checkedNum===0){
          this.$message({
            type: "warning",
            message: "未勾选随访患者"
          });
          return;
      }
      this.isShowAddFollowupPlan = true;
    },

    addFollowupPlan() {
      console.log("addFollowupPlan");
      
    },
    // 关闭
    closeAddFollowupPlan() {
      this.isShowAddFollowupPlan = false;
    },

    async handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.deleteOpedration(row.id, index);
        })
        .catch(() => {
          // console.log('取消');
        });
    },
    async deleteOpedration(id, index) {
      try {
        let res = await this.$apollo.mutate({
          mutation: removeCosmetRegistration,
          variables: {
            id
          }
        });
        // console.log(res)
        if (res.data.removeCosmetRegistration) {
          this.tableData.splice(index, 1);
          this.$message.success("已删除");
        }
      } catch (error) {
        console.log(error);
        this.$message.error("请重试");
      }
    },
    async clickPrev() {
      if (this.pageNumber === 1) {
        this.$message("已经是首页了");
      } else {
        this.pageNumber -= 1;
        this.tableData = await this.getFollowupPatientList();
      }
    },
    async clickNext() {
      if (this.tableData.length < 15) {
        this.$message("已经是最后一页了");
      } else {
        this.pageNumber += 1;
        this.tableData = await this.getFollowupPatientList();
      }
    },
    async refreshList() {
      this.searchDate = "";
      this.searchPatients = "";
      this.searchDoctor = "";
      this.pageSize = 15;
      this.pageNumber = 1;
      this.searchStartDate = "";
      this.searchEndDate = "";
      this.searchGroupName = "",
      this.searchNote = "",
      this.pageNumber = 1;
      this.tableData = await this.getFollowupPatientList();
      // this.$store.commit("hasNewcosmetRegistrationElective", false);
    },
    dbclickCell(row, column, cell, event) {
      // clearInterval(times)
      // // console.log("In dbclickCell, this.$store.state.cosmetRegistrationInput:",this.$store.state.cosmetRegistrationInput)
      // if (this.$store.state.cosmetRegistrationInput) {
      //       times= setTimeout(() => {
      //          this.dbclickCell(row, column, cell, event)
      //       }, 300);
      // } else {
        // 触发登记页面组件内变量清除，并获取 cosmetRegistrationElectiveId 对应的内容

        for(let item of this.tableData){
          if(item.id===row.id){
            item.checked = true;
            // console.log("row.id:",row.id, 'set checked true');
          }else{
            item.checked = false;
          }
        }
        this.$store.commit("setfollowupClearClick", true);
        // this.$store.commit("seteditcosmetRegistration", true);
        this.$store.commit("setfollowupInfo", {'followupPlan':row.followup_plan, 'followupResult':row.followup_result});
        this.$store.commit("setfollowupElectiveId", row.id);
        // this.$store.commit("setcosmetRegistrationRelevantId", row.relevant_info[0].id);
        console.log("In dbclickCell, patient_id:",row.patient_id, "  id:",row.id, "  followup_plan:",row.followup_plan, '  followupResult:',row.followup_result);
      // }
    },
    async getFollowupPatientList() {
      try {
        let queryObj = {
          page_size: this.pageSize,
          page_number: this.pageNumber,
          operation_doctor: this.searchDoctor,
          patient_name_id: this.searchPatients
        };
        if (this.searchDate) {
          queryObj.time_start = this.searchStartDate;
          queryObj.time_end = this.searchEndDate;
        }
        if (this.searchGroupName) {
          queryObj.queue_name = this.searchGroupName;
        }
        if (this.searchNote) {
          queryObj.note = this.searchNote;
        }

        // console.log("In getFollowupPatientList, queryObj:",queryObj);
        let res = await this.$apollo.query({
          query: getFollowupList,
          variables: queryObj,
          fetchPolicy: "no-cache"
        });
        console.log("In getFollowupPatientList, res:",res);
        let newData = res.data.followupinfo.data;
        this.pageTotal = res.data.followupinfo.count
        console.log("In getFollowupPatientList, item Total:",this.pageTotal);
        for (const A of newData) {
          A.followup_status = '进行中';
          if(A.create_time){
            A.create_time = moment(A.create_time).format("YYYY-MM-DD");
          }
          if(A.update_time){
            A.update_time = moment(A.update_time).format("YYYY-MM-DD");
          }          

          A.name = A.patient_info[0].name;
          A.id_in_hospital = A.patient_info[0].id_in_hospital;
          A.sex = A.patient_info[0].gender;
          A.diagnoses = A.patient_info[0].last_diagnosis_text;   
          if (A.followup_plan!==null && A.followup_plan!==undefined) {
            A.followup_plan_num = A.followup_plan.length;
            for(let tmp_item of A.followup_plan){  
              if(tmp_item.create_time){
                tmp_item.create_time = moment(tmp_item.create_time).format("YYYY-MM-DD HH:mm");
              } else{
                 tmp_item.create_time = '';
              }              
              if(tmp_item.update_time){
                tmp_item.update_time = moment(tmp_item.update_time).format("YYYY-MM-DD HH:mm");
              } else{
                 tmp_item.update_time = '';
              }
              if(tmp_item.send_datetime1){
                tmp_item.send_datetime1 = moment(tmp_item.send_datetime1).format("YYYY-MM-DD HH:mm");
              } else{
                 tmp_item.send_datetime1 = '';
              }              
              if(tmp_item.send_datetime2){
                tmp_item.send_datetime2 = moment(tmp_item.send_datetime2).format("YYYY-MM-DD HH:mm");
              } else{
                 tmp_item.send_datetime2 = '';
              }

              if(tmp_item.send_datetime3){
                tmp_item.send_datetime3 = moment(tmp_item.send_datetime3).format("YYYY-MM-DD HH:mm");
              } else{
                 tmp_item.send_datetime3 = '';
              }

              if(tmp_item.send_datetime4){
                tmp_item.send_datetime4 = moment(tmp_item.send_datetime4).format("YYYY-MM-DD HH:mm");
              } else{
                 tmp_item.send_datetime4 = '';
              }

              if(tmp_item.last_feedback_datetime){
                tmp_item.last_feedback_datetime = moment(tmp_item.last_feedback_datetime).format("YYYY-MM-DD HH:mm");
              } else{
                 tmp_item.last_feedback_datetime = '';
              }
            }
          }else{
            A.followup_plan_num = 0;
          }
          if (A.followup_result!==null && A.followup_result!==undefined) {
            A.followup_result_num = A.followup_result.length;
            for(let tmp_item of A.followup_result){ 
              tmp_item.template_data = JSON.parse(tmp_item.template_data);              
              if(tmp_item.create_time){
                tmp_item.create_time = moment(tmp_item.create_time).format("YYYY-MM-DD HH:mm");
              } else{
                 tmp_item.create_time = '';
              }
              if(tmp_item.update_time){
                tmp_item.update_time = moment(tmp_item.update_time).format("YYYY-MM-DD HH:mm");
              } else{
                 tmp_item.update_time = '';
              }  
            }
          }else{
            A.followup_result_num = 0;
          }
          // 是否勾选
          A.checked = false;         
        }
        console.log("In getFollowupPatientList, after handling:", newData);
        return newData;
      } catch (error) {
        console.log(error);
        this.$message.error("列表加载失败");
      }
    },

    // 打开修改随访患者的对话框
    async showRevise(index, row) {
      // 重置form表单验证状态
      try {
        if (this.$refs.form2Note) {
          this.$refs.form2Note.resetField();
        }

        if (this.$refs.form2_queue_name) {
          this.$refs.form2_queue_name.resetField();
        }
        // event.cancelBubble = true;
        this.activeName = "";
        this.reviseInfo = true;
        this.form2.followupId = row.id;
        this.form2.note = row.note;
        this.form2.queue_name = row.queue_name;
        console.log("reviseInfo:",this.reviseInfo);
      } catch (error) {
        this.$message.error(error.message);
      }
      
    },

    // 关闭（保存）修改随访患者的对话框
    async reviseFollowupPatient() {
      // 去掉所有空格
      this.form2.queue_name = this.form2.queue_name.replace(/^\s*|\s*$/g,'');
      const params = {
        id: this.form2.followupId,
        queue_name: this.form2.queue_name,
        note: this.form2.note
      };
      try {
        // let self = this;
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation(
              $id: Int!
              $queue_name: String
              $note: String
            ) {
              modifyFollowup(
                id: $id
                queue_name: $queue_name
                note: $note
              )
            }
          `,
          variables: params,
          fetchPolicy: "no-cache"
        });


        // 添加新的分组名称到后端
        if(this.form2.queue_name!==null && this.form2.queue_name!=='' && this.followupGroups.indexOf(this.form2.queue_name)===-1){         
          let res = await this.$apollo.query({
            query: gql`
              {
                me {
                  id
                }
              }
            `
          });
          const params_tmp = {
            doctor_id: res.data.me.id,
            queue_name: this.form2.queue_name,
          };

          let res_tmp = await this.$apollo.mutate({
            mutation: gql`
              mutation(
                $doctor_id: Int!
                $queue_name: String
              ) {
                addFollowupGroup(
                  doctor_id: $doctor_id
                  queue_name: $queue_name
                )
              }
            `,
            variables: params_tmp,
            fetchPolicy: "no-cache"
          });

          console.log("Add group name to db:",this.form2.queue_name);
          this.$message({
            type: "success",
            message: "添加新的分组名称 \'" + this.form2.queue_name + "\' 成功"
          });
        }

        this.reviseInfo = false;
        this.form2.queue_name = "";
        this.form2.note = "";
        // 刷新患者列表
        await this.refreshList();
        this.$message({
          type: "success",
          message: "修改随访患者信息成功"
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    
    // 添加随访患者， 并关闭对话框
    // 如果"patient_id + doctor_id + queue_name" 已经存在，则不在重新添加。 doctor_id为登录用户的ID
    async addFollowupPatient() {       
      // 去掉所有空格
      this.form2.queue_name = this.form2.queue_name.replace(/^\s*|\s*$/g,'');
      let queue_id = this.form2.queue_id;
      try {     
        // 添加新的分组名称到后端
        if(this.form2.queue_name!==null && this.form2.queue_name!=='' && this.followupQueueNames.indexOf(this.form2.queue_name)===-1){         
          // 获取登录医生ID
          let res = await this.$apollo.query({
            query: gql`
              {
                me {
                  id
                }
              }
            `
          });
          const params_tmp = {
            doctor_id: res.data.me.id,
            queue_name: this.form2.queue_name,
            queue_type: this.form2.queue_type,
            description: this.form2.description
          };
          // 添加新队列
          let result = await this.$apollo.mutate({
            mutation: gql`
              mutation(
                $doctor_id: Int!
                $queue_name: String
              ) {
                addFollowupQueue(
                  doctor_id: $doctor_id
                  queue_name: $queue_name
                  queue_type: $queue_type
                  description: $description
                )
              }
            `,
            variables: params_tmp,
            fetchPolicy: "no-cache"
          });
          let queue = JSON.parse(result.addFollowupQueue);
          queue_id = queue.id;
          console.log("Add queue_name name to db:",this.form2.queue_name);
          this.$message({
            type: "success",
            message: "添加新队列 \'" + this.form2.queue_name + "\' 成功"
          });
        }        
        
        // 逐个添加随访患者
        for(let item of this.newFollowupPatients){
          let params = {
            patient_id: item.patient_id,
            queue_id: queue_id,
            note: ''
          };
            
          let response = await this.$apollo.mutate({
            mutation: gql`
              mutation(
                $patient_id: Int!
                $queue_id: Int!
                note: String
              ) {
                addFollowupPatient(
                  patient_id: $patient_id
                  queue_id: $queue_id
                  note: $note
                )
                {
                  patient_id
                  doctor_id  
                  queue_id
                  note
                }
              }
            `,
            variables: params,
            fetchPolicy: "no-cache"
          });
        }



        this.reviseInfo = false;
        this.isAddPatient = false;
        this.$store.commit("setHasAddedNewFollowupPatient", true);
        this.newFollowupPatients = [];
        this.form2.queue_name = "";
        this.form2.note = "";
        // 刷新随访列表
        await this.refreshList();
        this.$message({
          type: "success",
          message: "添加随访患者成功"
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },

    // 关闭（不保存）修改随访患者的对话框    
    reviseInfoClose() {
      // 初始化状态
      // this.$refs.form2Note.resetField();
      // this.$refs.form2_queue_name.resetField();
      this.reviseInfo = false;
      this.isAddPatient = false;
      this.newFollowupPatients = [];
      // this.form2IdDisabled = true;
      this.form2 = {
        // 患者的id
        id: "",
        note: "",
        queue_name: ""
      };
    },
    
    async getFollowupQueues(){
      let newArr = []; 
      let res = await this.$apollo.query({
        query: gql`
          {
            me {
              id
            }
          }
        `
      });
      let doctor_id = res.data.me.id;
      res = await this.$apollo.query({
        query: gql`query($doctor_id: Int){
                    followupQueues(doctor_id: $doctor_id) 
                }`,
        fetchPolicy: "no-cache",
        variables: {
          doctor_id: doctor_id,
        },
      });
      // newArr = res.data.followupQueues;
      this.followupQueues = res.data.followupQueues;
      if(res.data.followupQueues){
        for(let item of res.data.followupQueues){
          newArr.push(item.queue_name);
        }
      }
      this.followupQueueNames = newArr;
      console.log("get followupQueues for doctor:",doctor_id, ", queue names:",newArr);
      return newArr;
    },
    
    // 队列名称输入框，自动下拉选项
    async querySearchQueueName(queryString, callback) {
      const names = await this.getFollowupQueues();
      let newArr = [];
      let i = 0;
      for (const A of names) {
        i += 1;
        newArr.push({
              value: A,
              id: i
        });
      }
      callback(newArr);
    },
    // 选择历史队列名称
    selectQueueName(val) {
      this.form2.queue_name = val.value;
      for(let item of this.followupQueues){
          if(item.queue_name===val.value){
            this.form2.queue_type = item.queue_type;
            this.form2.queue_id = item.id;
            this.form2.description = item.description;            
            break;
          }
      }
    },

    selectsearchGroupName(val) {
      this.searchGroupName = val.value;
    },

    // 单行勾选或取消勾选
    handleCheckChange(row){
      if(row!==undefined && row!==null){
        console.log("In handleCheckChange, row.id && row.name:", row.id, row.name, row.checked);
      }
      var num = 0; 
      for (const item of this.tableData) {
          if (item.checked){
            num += 1;
          }
      }
      this.checkedNum = num;
    },

    // 全部勾选或取消勾选
    selectchageall() {
      // 获取真假值默认
      this.checkAll = !this.checkAll;
      this.isIndeterminate = false;      
      console.log("In selectchageall, val:", this.checkAll);
      if (this.checkAll){
        for (const item of this.tableData) {
          item.checked = true;
        }
        this.checkedNum = this.tableData.length;
        // this.followup_disabled = false;
      } else {
        for (const item of this.tableData) {
          item.checked = false;
        }     
        this.checkedNum = 0;
        // this.followup_disabled = true
      }
    },

  }
};
</script>
<style lang="less">

.resetFollowup {
  .el-dialog__title {
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
  .el-dialog__body {
    padding: 0 20px 30px;
  }
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-input__inner {
    border-radius: 8px;
    height: 46px;
    color: #6b6b6b;
    font-size: 18px;
  }
  .el-input__prefix {
    left: 250px;
    i {
      font-size: 35px !important;
      color: #797979;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
  .el-input__icon {
    line-height: 46px;
  }
  .el-input__suffix-inner {
    i {
      font-size: 30px !important;
      color: #797979 !important;
    }
  }
  .el-input__suffix {
    right: 10px !important;
  }
  .el-button--primary {
    border-radius: 6px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-radio-button__inner {
    width: 100%;
    height: 46px;
    border-radius: 8px;
    line-height: 23px;
    font-size: 20px;
    font-weight: 600;
  }
}

.dialog {
  // min-width: 1205px;
  display: flex;
  align-items: center;
  .navBorder {
    width: 100%;
    height: 2px;
    background: #4da3c0;
  }
  .popTitleDialog {
    font-size: 20px;
    font-weight: 600;
    color: black;
    margin-bottom: 15px;
    margin-top: 15px;
    text-indent: 12px;
  }
  .popInput {
    width: 294px;
    border: 1px solid #c0c0c0 !important;
    border-radius: 8px;
    height: 48px;
    box-sizing: border-box;
  }
  .popInputSingle2 {
    width: 630px !important;
  }
  .leftItemSubmit2 {
    width: 298px;
    height: 42px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .isBW {
    display: flex;

    .isBWItem {
      flex: 1;
      font-size: 20px !important;
      font-weight: 600;
    }
    .activeBW {
      background: white;
      color: black;
    }
  }
}

#modifyFollowupPatient {
  // display: flex;
  padding: 0 15px;
  box-sizing: border-box;
}

.electiveOperationList {
  width: 100%;
  height: 100%;

  .el-col-8 {
    padding-left: 24px;
    box-sizing: border-box;
    display: flex;
  }

  .el-form-item__label {
    color: black;
    font-weight: 600;
  }

  .el-form-item {
    width: 100% !important;
    display: flex;
    margin-top: 10px;
    padding-left: 24px;
    box-sizing: border-box;
    margin-bottom: 0;
  }

  .el-form-item__content {
    flex: 1;
  }

  .el-input input {
    width: 100%;
  }

  .el-range-editor {
    flex: 1;
    height: 36px;
  }

  .el-table {
    height: 79%;
  }

  .el-table__body-wrapper {
    height: calc(~"100% - 48px");
    overflow-y: auto;
  }
  .el-pagination {
    height: 34px !important;
    display: flex;
    justify-content: center;
    align-items: center;


    .btn-next,
    .btn-prev {
      line-height: 38px !important;
    }
  }
}
</style>
<style lang="less" scoped>
.electiveOperationList {
  .line {
    width: 100%;
    height: 2px;
    background: #4ea3c0;
  }

  .lineGray {
    background: #b8b8b8;
  }

  .nav {
    .title {
      display: flex;
      color: #4ea3c0;
      // height: 40px;
      line-height: 45px;

      i {
        // text-indent: 50px;
        font-size: 30px;
      }

      p {
        text-indent: 10px;
        font-size: 18px;
      }
    }
  }

  .search {
    padding: 0 10px;
    box-sizing: border-box;
    margin-top: 12px;
    height: 48px;

    .dateTitle {
      margin-right: 10px;
      line-height: 36px;
      font-size: 14px;
      font-weight: 600;
      color: black;
    }

    .leftItemSubmit {
      height: 40px;
    }

    .searchInput {
      padding-left: 20px;
      box-sizing: border-box;
    }
  }

  .btnBottom {
    display: flex;
    justify-content: flex-end;
    position: relative;

    .yuyuetips {
      position: absolute;
      left: 24px;
    }

    // flex-direction: column-reverse;
  }

  .fotter {
    width: 100%;
    height: 100%;

    .pageFen {
      display: flex;
      justify-content: center !important;
      height: 180px;
      line-height: 37px !important;
      padding-top: 10px;
    }
  }
}
</style>
